// import * as types from '../constants/actionTypes';
// import { STRIPE_BASE_URL, STRIPE_API_VERSION, STRING_X_APP_ID_VALUE, STRING_X_APP_KEY_VALUE, PRODUCTION_RELEASE } from '../constants/general';
import CustomFormData from '../utils/CustomFormData';
import MHCError from '../utils/MHCError';
// import { AsyncStorage } from 'react-native';
export const STRIPE_BASE_URL = 'https://api.stripe.com/v1';
export const STRIPE_API_VERSION = "2017-08-15";
const ROOT_URL = process.env.REACT_APP_API_ROOT_URL;

//import FlurryAnalytics from 'react-native-flurry-analytics';

const className = 'stripeActions'

export const GET_EPHEMERAL_KEY_REQUEST = 'GET_EPHEMERAL_KEY_REQUEST';
export const GET_EPHEMERAL_KEY_SUCCESS = 'GET_EPHEMERAL_KEY_SUCCESS';
export const GET_EPHEMERAL_KEY_FAILURE = 'GET_EPHEMERAL_KEY_FAILURE';
export const GET_CUSTOMER_REQUEST = 'GET_CUSTOMER_REQUEST';
export const GET_CUSTOMER_SUCCESS = 'GET_CUSTOMER_SUCCESS';
export const GET_CUSTOMER_FAILURE = 'GET_CUSTOMER_FAILURE';
export const CREATE_TOKEN_REQUEST = 'CREATE_TOKEN_REQUEST';
export const CREATE_TOKEN_SUCCESS = 'CREATE_TOKEN_SUCCESS';
export const CREATE_TOKEN_FAILURE = 'CREATE_TOKEN_FAILURE';
export const CREATE_CARD_REQUEST = 'CREATE_CARD_REQUEST';
export const CREATE_CARD_SUCCESS = 'CREATE_CARD_SUCCESS';
export const CREATE_CARD_FAILURE = 'CREATE_CARD_FAILURE';
export const DELETE_CARD_REQUEST = 'DELETE_CARD_REQUEST';
export const DELETE_CARD_SUCCESS = 'DELETE_CARD_SUCCESS';
export const DELETE_CARD_FAILURE = 'DELETE_CARD_FAILURE';
export const SET_DEFAULT_CARD_REQUEST = 'SET_DEFAULT_CARD_REQUEST';
export const SET_DEFAULT_CARD_SUCCESS = 'SET_DEFAULT_CARD_SUCCESS';
export const SET_DEFAULT_CARD_FAILURE = 'SET_DEFAULT_CARD_FAILURE';
export const STRING_X_APP_ID_VALUE = "qGNj1cCRdVg7izFVajV125LWhIrbIkIC"; //<===== please change this when clone
export const STRING_X_APP_KEY_VALUE = "N7QdgG79Lllsc2EJNQm9V0RDNJbH5Sie"; //<===== please change this when clone

export function getEphemeralKeyRequest() {
    return {
        type: GET_EPHEMERAL_KEY_REQUEST
    };
}

export function getEphemeralKeySuccess(ephemeralKey) {
    return {
        type: GET_EPHEMERAL_KEY_SUCCESS,
        ephemeralKey
    };
}

export function getEphemeralKeyFailure(error) {
    return {
        type: GET_EPHEMERAL_KEY_FAILURE,
        error
    };
}

export function getCustomerRequest() {
    return {
        type: GET_CUSTOMER_REQUEST
    };
}

export function getCustomerSuccess(customer) {
    return {
        type: GET_CUSTOMER_SUCCESS,
        customer
    };
}

export function getCustomerFailure(error) {
    return {
        type: GET_CUSTOMER_FAILURE,
        error
    };
}

export function createTokenRequest() {
    return {
        type: CREATE_TOKEN_REQUEST
    };
}

export function createTokenSuccess(token) {
    return {
        type: CREATE_TOKEN_SUCCESS,
        token
    };
}

export function createTokenFailure(error) {
    return {
        type: CREATE_TOKEN_FAILURE,
        error
    };
}

export function createCardRequest() {
    return {
        type: CREATE_CARD_REQUEST
    };
}

export function createCardSuccess(card) {
    return {
        type: CREATE_CARD_SUCCESS,
        card
    };
}

export function createCardFailure(error) {
    return {
        type: CREATE_CARD_FAILURE,
        error
    };
}

export function deleteCardRequest() {
    return {
        type: DELETE_CARD_REQUEST
    };
}

export function deleteCardSuccess(cardID) {
    return {
        type: DELETE_CARD_SUCCESS,
        cardID
    };
}

export function deleteCardFailure(error) {
    return {
        type: DELETE_CARD_FAILURE,
        error
    };
}

export function setDefaultCardRequest() {
    return {
        type: SET_DEFAULT_CARD_REQUEST
    };
}

export function setDefaultCardSuccess(customer) {
    return {
        type: SET_DEFAULT_CARD_SUCCESS,
        customer
    };
}

export function setDefaultCardFailure(error) {
    return {
        type: SET_DEFAULT_CARD_FAILURE,
        error
    };
}



export function getEphemeralKeyAction() {
    return (dispatch, getState) => {
        dispatch(getEphemeralKeyRequest());
        
        // let urlString = getState().appLaunch.appLaunch.production_url_api + '/users/' + getState().user.user.uuid + '/ephemeralKey';
        let urlString = ROOT_URL + '/users/' + getState().user.user.uuid + '/ephemeralKey';
        console.log(urlString);
        console.log(getState().user.user.accessToken)
        return fetch(urlString, {
            method: 'GET',
            headers: {
                'AccessToken': getState().user.user.accessToken,
            }
        })
            .then(response => {
                console.log("THIS", response)
                if (response.ok) {
                    console.log('Response Success');
                    return response.json().then(json => {
                        dispatch(getEphemeralKeySuccess(json));
                    });
                } else {
                    console.log('Response Error');
                    let mhcError = new MHCError();
                    return mhcError.setResponse(response, 'Failed to get ephemeral key').then(() => {
                        dispatch(getEphemeralKeyFailure(mhcError));
                    });
                }
            })
            .catch(error => {
                console.log('Parse Error:', error);
                let mhcError = new MHCError(500, 'Failed to get ephemeral key', 'Failed to get ephemeral key');
                dispatch(getEphemeralKeyFailure(mhcError));
            });
    };
}

export function getProfileEphemeralKeyAction() {
    return (dispatch, getState) => {
        dispatch(getEphemeralKeyRequest());
        
        // let urlString = getState().appLaunch.appLaunch.production_url_api + '/users/' + getState().user.user.uuid + '/ephemeralKey';
        let urlString = ROOT_URL + '/profile/users/' + getState().user.user.uuid + '/ephemeralKey';
        console.log(urlString);
        console.log(getState().user.user.accessToken)
        return fetch(urlString, {
            method: 'GET',
            headers: {
                'AccessToken': getState().user.user.accessToken,
            }
        })
            .then(response => {
                console.log("THIS", response)
                if (response.ok) {
                    console.log('Response Success');
                    return response.json().then(json => {
                        dispatch(getEphemeralKeySuccess(json));
                    });
                } else {
                    console.log('Response Error');
                }
            })
            .catch(error => {
                console.log('Parse Error:', error);
            });
    };
}

export function getCustomerAction() {
    return (dispatch, getState) => {
        dispatch(getCustomerRequest());

        let urlString = STRIPE_BASE_URL + '/customers/' + getState().stripe.ephemeralKey.ephemeralKey.associated_objects[0].id;
        console.log(urlString);

        return fetch(urlString, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + getState().stripe.ephemeralKey.ephemeralKey.secret,
                'Stripe-Version': STRIPE_API_VERSION
            }
        })
            .then(response => {
                if (response.ok) {
                    console.log('Response Success');
                    return response.json().then(json => {
                        dispatch(getCustomerSuccess(json));
                    });
                } else {
                    console.log('Response Error');
                    return response.json().then(json => {
                        let error = json['error'];
                        let mhcError = new MHCError(response.status, error.message, error.type);
                        dispatch(getCustomerFailure(mhcError));
                    })
                }
            })
            .catch(error => {
                console.log('Parse Error:', error);
                let mhcError = new MHCError(500, 'Failed to load', 'Failed to load');
                dispatch(getCustomerFailure(mhcError));
            });
    };
}

export function createCardAction(tokenID) {
    return (dispatch, getState) => {
        dispatch(createCardRequest());

        let urlString = STRIPE_BASE_URL + '/customers/' + getState().stripe.ephemeralKey.ephemeralKey.associated_objects[0].id + '/sources';
        console.log(urlString);

        var params = {
            'source': tokenID
        }

        return fetch(urlString, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + getState().stripe.ephemeralKey.ephemeralKey.secret,
                'Stripe-Version': STRIPE_API_VERSION,
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: CustomFormData.formUrlEncoded(params)
        })
            .then(response => {
                if (response.ok) {
                    console.log('Response Success');
                    return response.json().then(json => {
                        dispatch(createCardSuccess(json));
                        return json
                    });
                } else {
                    console.log('Response Error');
                    return response.json().then(json => {
                        console.log('json:',json);
                        let error = json['error']
                        let mhcError = new MHCError(response.status, error.message, error.type);
                        dispatch(createCardFailure(mhcError));
                    })
                }
            })
            .catch(error => {
                console.log('Parse Error:', error);
                let mhcError = new MHCError(500, 'Failed to add card', 'Failed to add card');
                dispatch(createCardFailure(mhcError));
            });
    };
}

export function deleteCardAction(cardID) {
    return (dispatch, getState) => {
        dispatch(deleteCardRequest());

        let urlString = STRIPE_BASE_URL + '/customers/' + getState().stripe.ephemeralKey.ephemeralKey.associated_objects[0].id + '/sources/' + cardID;
        console.log(urlString);

        return fetch(urlString, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + getState().stripe.ephemeralKey.ephemeralKey.secret,
                'Stripe-Version': STRIPE_API_VERSION,
            }
        })
            .then(response => {
                if (response.ok) {
                    console.log('Response Success');
                    return response.json().then(json => {
                        dispatch(deleteCardSuccess(json.id));
                    });
                } else {
                    console.log('Response Error');
                    return response.json().then(json => {
                        let error = json['error']
                        let mhcError = new MHCError(response.status, error.message, error.type);
                        dispatch(deleteCardFailure(mhcError));
                    })
                }
            })
            .catch(error => {
                console.log('Parse Error:', error);
                let mhcError = new MHCError(500, 'Failed to delete card', 'Failed to delete card');
                dispatch(deleteCardFailure(mhcError));
            });
    };
}

export function setDefaultCardAction(cardID) {
    return (dispatch, getState) => {
        dispatch(setDefaultCardRequest());

        let urlString = STRIPE_BASE_URL + '/customers/' + getState().stripe.ephemeralKey.ephemeralKey.associated_objects[0].id;
        console.log(urlString);

        var params = {
            'default_source': cardID
        }

        return fetch(urlString, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + getState().stripe.ephemeralKey.ephemeralKey.secret,
                'Stripe-Version': STRIPE_API_VERSION,
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: CustomFormData.formUrlEncoded(params)
        })
            .then(response => {
                if (response.ok) {
                    console.log('Response Success');
                    return response.json().then(json => {
                        dispatch(setDefaultCardSuccess(json));
                    });
                } else {
                    console.log('Response Error');
                    return response.json().then(json => {
                        let error = json['error']
                        let mhcError = new MHCError(response.status, error.message, error.type);
                        dispatch(setDefaultCardFailure(mhcError));
                    })
                }
            })
            .catch(error => {
                console.log('Parse Error:', error);
                let mhcError = new MHCError(500, 'Failed to set default card', 'Failed to set default card');
                dispatch(setDefaultCardFailure(mhcError));
            });
    };
}

export function createTokenAction(number, expMonth, expYear, cvc) {
    return (dispatch, getState) => {
        dispatch(createTokenRequest());

        let urlString = STRIPE_BASE_URL + '/tokens';
        console.log(urlString);

        var params = {
            'card[number]': number,
            'card[exp_month]': expMonth,
            'card[exp_year]': expYear,
            'card[cvc]': cvc,
        }

        return fetch(urlString, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + getState().appLaunchConfig.appLaunchExtra.production_stripe_key,
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: CustomFormData.formUrlEncoded(params)

        })
            .then(response => {
                if (response.ok) {
                    console.log('Response Success');
                    return response.json().then(json => {
                        dispatch(createTokenSuccess(json));
                    });
                } else {
                    console.log('Response Error');
                    return response.json().then(json => {
                        let error = json['error']
                        let mhcError = new MHCError(response.status, error.message, error.type);
                        dispatch(createTokenFailure(mhcError));
                    })
                }
            })
            .catch(error => {
                console.log('Parse Error:', error);
                let mhcError = new MHCError(500, 'Failed to create token', 'Failed to create token');
                dispatch(createTokenFailure(mhcError));
            });
    };
}



